export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10934.f0a23cf8.jpg";